export const GET_CHROME_URL = 'https://www.google.com/chrome/'
export const INSTALL_CHROME_URL =
    'https://support.google.com/chrome/answer/95346?hl=en'

export const defaultErrorScreenProps = {
    title: '',
    subText: '',
    infoCopy: '',
    ctaTitle: '',
    buttonProps: {},
}
